import { render, staticRenderFns } from "./PrivacyPolice.vue?vue&type=template&id=d3bfdeae"
var script = {}
import style0 from "./PrivacyPolice.vue?vue&type=style&index=0&id=d3bfdeae&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports